import { useContext } from "react";
import { SportsCampsContext } from "../context/sportscamps-context";

const LoadingMore = () => {
	const { dictionaryWords } = useContext(SportsCampsContext);

	return (
		<>
			<header className="c-detail-fiche__header">
				<div className="text">
					<i
						className="fa fa-close"
						ng-click="hideSportsCampDetail()"
					></i>
					<h2 className="title"></h2>
				</div>
			</header>
			<div className="c-detail-fiche__body">
				<div className="practical">
					<div className="left">
						<div className="inner">
							<div className="top"></div>
							<div className="bottom"></div>
						</div>
					</div>
					<div className="right">
						<div className="inner">
							<div className="info">
								<div className="status loading">
									<i className="loader"></i>
									<h3>{dictionaryWords.loading}</h3>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default LoadingMore;
